import axios from 'axios';

import { applyTracing } from './helpers/tracingInterceptor';

const axiosUI = axios.create();

// redirect authentication failure requests to login page
// with a ref query parameter
axiosUI.interceptors.response.use(null, error => {
  const isLoginPage = window.location.pathname === '/login';
  const isSessionCheckRequest = error?.config?.url?.includes('/api/auth/session');

  const shouldRedirect =
    !isLoginPage &&
    !isSessionCheckRequest &&
    (error?.response?.data?.message === 'REDIRECT_TO_LOGIN' ||
    error?.response?.status === 401);

  if (shouldRedirect) {

    // this "returnTo" query value will be captured by
    // our auth route to restore users session
    window.location.href = `/login?returnTo=${window.location.pathname}`;
  }

  return Promise.reject(error);
});

applyTracing(axiosUI, { spanName: 'client_api_call' });

export default  axiosUI;
